import { observer } from 'mobx-react-lite'
import { TransferCard } from '@/features/legends/transfer/components/TransferCard'
import type { LegendTransferViewModel } from '@/features/legends/transfer/LegendTransferViewModel'

const testId = 'legend-transfer'

export interface TransferCardContainerProps {
  vm: LegendTransferViewModel
}

export const TransferCardContainer = observer(function TransferCardContainer({
  vm,
}: TransferCardContainerProps) {
  return (
    <TransferCard
      isExportPending={vm.exportVersion.pending}
      isImportPending={vm.importVersion.pending}
      isExportDisabled={vm.isExportDisabled}
      isImportDisabled={vm.isImportDisabled}
      onExport={vm.exportVersion}
      onImport={vm.importVersion}
      testId={testId}
    />
  )
})
